<template>
  <div class="background">
    <transition name="zoom-in-left">
        <router-view
            :key="$route.fullPath"
        ></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "main"
}
</script>

<style scoped>
.background{
  height: 94%;
  padding: 4px 16px;
  background-color: white;
  overflow: auto;
}

/* 从左上铺开动画（纯原生，不影响任何组件） */
.zoom-in-left-enter-active {
  animation: zoomInLeft 0.6s ease;
}
.zoom-in-left-leave-active {
  /* 关键：离开无动画 */
  display: none !important;
}

@keyframes zoomInLeft {
  0% {
    opacity: 0;
    transform: scale(0.2);
    transform-origin: left top;
  }
  100% {
    opacity: 1;
    transform: scale(1);
    transform-origin: left top;
  }
}
</style>